import React, { useEffect } from 'react'
import { Navigate, useOutlet } from 'react-router-dom'
import { useLocation } from 'react-router'
import useMarkerStore from '../stores/emulator/markerStore'
import { useEmulatorStore } from '../stores/emulator/store.tsx'
import { useAuth } from './hooks/useAuth'

const ADMIN_ONLY_ROUTES = ['/license', '/data']

export const ProtectedLayout = () => {
  const { client } = useAuth()
  const outlet = useOutlet()
  const location = useLocation()

  const getEmulatorsSSE = useEmulatorStore.getState().getEmulatorsSSE
  const initMarkers = useMarkerStore.getState().initMarkers
  const createDevices = useEmulatorStore.getState().createDevices

  useEffect(() => {
    if (!client) {
      return
    }
    const token = client.token
    if (token) {
      getEmulatorsSSE()
      initMarkers()
      createDevices()
    }
  }, [client, getEmulatorsSSE, createDevices, initMarkers])

  if (!client) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  let isAdmin = false
  client?.role_TYPE?.forEach((role) => {
    if (role.authority.includes('ROLE_ADMIN')) {
      isAdmin = true
    }
  })
  // If the current path is the root path, redirect based on the user's role.
  if (location.pathname === '/') {
    if (isAdmin) {
      return <Navigate to="/license" />
    } else {
      return <Navigate to="/gps" />
    }
  }

  if (ADMIN_ONLY_ROUTES.includes(location.pathname) && !isAdmin) {
    return <Navigate to="/access-denied" replace />
  }

  return (
    <div>
      {/* <Navbar isAdmin={isAdmin} /> */}
      {outlet}
    </div>
  )
}
